export const fetchStatus = {
    notStarted: "notStarted",
    completed: "completed",
    loading: "loading",
};

export const errorConst = {
    failedToFetch: "Failed to fetch",
};

export const errorConstStatus = {
    failedToFetch: 502,
    failedToFetchTimeOut: 504,
};
